import { render } from "./BlFormFieldCollectionItem.vue?vue&type=template&id=4c83c4a6"
import script from "./BlFormFieldCollectionItem.vue?vue&type=script&lang=js"
export * from "./BlFormFieldCollectionItem.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__